module.exports = __webpack_public_path__ + "img/biank1.89bc8c5f.png";